import axios from "axios";

import {ActionType} from "../actionTypes";

import envManager from "../../com/envManager/EnvManager";

import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {Action as FlippingFlyerActions} from "../actions/flippingFlyerActions";
import {Action as GuiSettingsActions} from "../actions/guiSettingsActions";
import {Action as FlyersActions} from "../actions/flyersActions";
import {Action as PromotionsItemsActions} from "../actions/promotionsItemsActions";
import {Action as SpecificSaleTypes} from "../actions/saleTypeActions";
import {Action as CheckoutUrlSettingActions} from "../actions/flyerConversionSettingsActions";
import {Action as SellingUnitsActions} from "../actions/sellingUnitsActions";


import {Dispatch} from "redux";
import {FlippingFlyerState} from "../reducers/flippingFlyerReducer";
import {
    UserDto,
    FlyerDto,
    flyerDtoInitialState,
    ErrorDtoFactory, SaleTypeDto
} from "../../dtos";
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";
import {FlyersState} from "../reducers/flyersReducer";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE,
} from "../../globals/EventDispatcher";

export const resetFlyerState = () => {
    return async (dispatch: Dispatch<FlyerDetailsActions>) => {
        dispatch({
            type: ActionType.RESET_FLYER_STATE,
        });
    };
};

export const updateFlippingFlyerState = (newState: FlippingFlyerState) => {
    return async (dispatch: Dispatch<FlippingFlyerActions>) => {
        dispatch({
            type: ActionType.FLIPPING_FLYER_DATA_CHANGE_EVENT,
            payload: newState,
        });
    };
};

export const getFlippingFlyer = (flyerId: number, signal?: AbortSignal, isForPreview: boolean = false) => {

    let userDtoStr = localStorage.getItem("userDto");
    if(isForPreview){
        userDtoStr = localStorage.getItem("userDtoForPreview");
    }
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | GuiSettingsActions | SpecificSaleTypes | PromotionsItemsActions | CheckoutUrlSettingActions | SellingUnitsActions>
    ) => {
        dispatch({
            type: ActionType.GET_FLIPPING_FLYER_START,
        });
        try {
            const config = {
                signal: signal,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            let result = await axios.get(
                `${envManager.flyerEditorServerAddress}/api/flyers/${flyerId}`,
                config
            );
            let data = result.data.data;

            if (data.flyer === null) {
                // New Flyer Mode
                data.flyer = {
                    ...flyerDtoInitialState,

                    // set default gui setting
                    flyGusRec: {...data.guiSettings[0]},
                };
            }

            // left
            const flyerDetailPayload: FlyerDetailsState = {
                ...data.flyer,
            };

            // right
            const flippingFlyerPayload: FlippingFlyerState = {
                ...data,
                flyerDto: {...data.flyer},
            };
            dispatch({
                type: ActionType.GET_CONVERSION_URL_SUCCESS,
                payload: data.accountSetting.conversion
            })
            dispatch({
                type: ActionType.SET_SALE_UNITS_FOR_FLYER,
                payload: data.sellingUnits
            })

            dispatch({
                type: ActionType.GET_FLIPPING_FLYER_SUCCESS,
                payload: flippingFlyerPayload,
            });

            dispatch({
                type: ActionType.GET_FLIPPING_FLYER_COMPLETED,
                payload: '',
            });

            dispatch({
                type: ActionType.SET_SALE_TYPES_FOR_SPECIFIC_FLYER,
                payload: data.saleTypes.filter((saleType: SaleTypeDto) => {
                    if (saleType.isAssignedToAccount) {
                        return saleType;
                    }
                }),
            });
            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: flyerDetailPayload,
            });

            dispatch({
                type: ActionType.GET_GUI_SETTINGS_SUCCESS,
                payload: data.guiSettings,
            });

            dispatch({
                type: ActionType.SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE,
                payload: data.flyer.flyerPages
            })

        } catch (err) {
            dispatch({
                type: ActionType.GET_FLIPPING_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const clearDataForFlyer = () => {
    return async (dispatch: Dispatch<FlippingFlyerActions>) => {
        dispatch({
            type: ActionType.CLEAR_DATA_FROM_FLYER,
        });
    };
};

export const saveFlyer = (
    flyerDetailsState: FlyerDetailsState,
    flippingFlyerState: FlippingFlyerState,
    flyersState: FlyersState,
    isNew: boolean
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    // prepare flyerDto
    let flyerDto: FlyerDto = {
        ...flippingFlyerState.flyerDto!,
        ...flyerDetailsState,
        flyAcuRecId: userDto.userId,
    };

    flyerDto.flyCode = flyerDetailsState.flyCode;
    flyerDto.flyCaption = flyerDetailsState.flyCaption;
    flyerDto.flyDisplayCaption = flyerDetailsState.flyDisplayCaption;
    flyerDto.flyDesc = flyerDetailsState.flyDesc;

    flyerDto.flyValidFromUtc = flyerDetailsState.flyValidFromUtc;
    flyerDto.flyValidToUtc = flyerDetailsState.flyValidToUtc;
    flyerDto.flyCreatedUtc = flyerDetailsState.flyCreatedUtc;
    flyerDto.flyModifiedUtc = flyerDetailsState.flyModifiedUtc;

    // FlyerType
    flyerDto.flyFltRecId = flyerDetailsState.flyFltRec.fltRecId;
    flyerDto.flyFltRec = flyerDetailsState.flyFltRec;

    // LanguageCulture
    flyerDto.flyLacRecId = flyerDetailsState.flyLacRec.lacRecId;
    flyerDto.flyLacRec = flyerDetailsState.flyLacRec;

    flyerDto.flyGusRec = flyerDetailsState.flyGusRec!;
    flyerDto.flygusRecId = flyerDetailsState.flyGusRec!.gusRecId;

    // excels files
    //
    // if (flyerDetailsState.flyConversionEmail?.trim().length === 0) {
    // } else {
    //     flyerDto.flyConversionEmail = flyerDetailsState.flyConversionEmail;
    // }

    delete flyerDto.flyerPages;
    delete flyerDto.flyerPromoItems;
    delete flyerDto.flyerPromos;
    //

    // excels files

    // prepare files data
    const formData = new FormData();

    //
    formData.append("flyerDto", JSON.stringify(flyerDto));

    // page files
    // logo file

    // prepare flyerDto

    // prepare files d// page files

    // logo file
    if (
        flippingFlyerState.uploadLogo != null ||
        flippingFlyerState.uploadLogo != undefined
    ) {
        let logo = flippingFlyerState.uploadLogo!;
        if (logo.file != null) {
            formData.append(`logo`, logo.file, logo.file.name);
        }
    }

    //
    return async (
        dispatch: Dispatch<FlippingFlyerActions
            | FlyerDetailsActions
            | GuiSettingsActions
            | FlyersActions
            | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_FLIPPING_FLYER_START,
        });

        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let result = await axios.post(
                `${envManager.flyerEditorServerAddress}/api/flyerEditor/${userDto.userId}`,
                formData,
                config
            );
            let data = result.data.data;

            // await handleFlyerExcelsFiles(
            //     flippingFlyerState,
            //     data,
            //     flyerDto,
            //     dispatch
            // );
            //
            const flyerDetailPayload: FlyerDetailsState = {
                ...flyerDetailsState,
                ...data.flyer,
            };
            // right
            const flippingFlyerPayload: FlippingFlyerState = {
                ...flippingFlyerState,
                flyerDto: {...data.flyer},
            };

            dispatch({
                type: ActionType.POST_FLIPPING_FLYER_SUCCESS,
                payload: flippingFlyerPayload,
            });
            if (isNew) {
                const flyersStatePayload: FlyersState = {
                    ...flyersState,
                    flyers: [data.flyer, ...flyersState.flyers],
                };
                dispatch({
                    type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                    payload: flyerDetailPayload,
                });
                dispatch({
                    type: ActionType.CHANGE_FLYERS_STATE,
                    payload: flyersStatePayload,
                });
                // dispatch({
                //     type: ActionType.SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE,
                //     payload: data.flyer.flyerPages
                // })
            } else {
                const flyers: FlyerDto[] = flyersState.flyers.map((key: FlyerDto) => {
                    if (data.flyer.flyRecId === key.flyRecId) {
                        return data.flyer;
                    } else {
                        return key;
                    }
                });
                const flyersStatePayload: FlyersState = {
                    ...flyersState,
                    flyers: [...flyers],
                };
                dispatch({
                    type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                    payload: flyerDetailPayload,
                });

                dispatch({
                    type: ActionType.CHANGE_FLYERS_STATE,
                    payload: flyersStatePayload,
                });
                // dispatch({
                //     type: ActionType.SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE,
                //     payload: data.flyer.flyerPages
                // })
            }
            dispatchEventDataType<string | undefined>(
                EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE,
                data.flyer.flyCaption
            );
        } catch (err) {
            dispatch({
                type: ActionType.POST_FLIPPING_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const updateFlyersState = (flyersState: FlyersState) => {
    return async (dispatch: Dispatch<FlyersActions>) => {
        dispatch({
            type: ActionType.CHANGE_FLYERS_STATE,
            payload: {
                ...flyersState
            }
        });
    };
}

// if exception occure inside this function still dispatch new data to ui
// => catch the exception inside the function

export const savePageSpotsData = (
    flyRecId: number,
    spotsFile: File,
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | GuiSettingsActions>
    ) => {
        dispatch({
            type: ActionType.POST_FLYER_SPOTS_START,
        });

        try {
            let result: any = await postPageSpotsData(
                flyRecId,
                spotsFile,
                languageCultureCode
            );

            var flyer = result.data.data.flyer;
            dispatch({
                type: ActionType.POST_FLYER_SPOTS_SUCCESS, payload: {
                    flyer: flyer,
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });

            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: flyer,
            });


            dispatch({type: ActionType.POST_FLYER_SPOTS_COMPLETED});
        } catch (err) {
            dispatch({
                type: ActionType.POST_FLYER_SPOTS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getExcelFileWithCurrentDataForFramesData = (flyerID: number, flyerCaption: string) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_START,
        });

        try {
            let result: any = await getFramesDataExcel(flyerID, userDto.userId);
            dispatch({type: ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_SUCCESS});

            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${flyerCaption}-Frames.xlsx`); //this is the name with which the file will be downloaded
            link.click();
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 0);

            dispatch({type: ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.GET_CURRENT_DATA_FRAMES_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


const getFramesDataExcel = (flyerId: number, userId: number) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPageSpots/DownloadFlyerSpotsExcel?userId=${userId}&flyerId=${flyerId}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    // "Content-Type": "multipart/form-data",
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
            });
            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })

        }
    });
};


export const savePagePromosData = (
    flyRecId: number,
    promosFile: File,
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_FLYER_PROMOS_START,
        });

        try {
            let result: any = await postPromotionsTemplate(
                flyRecId,
                promosFile,
                languageCultureCode
            );

            var flyer = result.data.data.flyer;

            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({type: ActionType.POST_FLYER_PROMOS_SUCCESS, payload: flyer});

            dispatch({type: ActionType.POST_FLYER_PROMOS_COMPLETED});
        } catch (err) {
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_FLYER_PROMOS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const savePagePromosAndItemsData = (
    flyRecId: number,
    promosFile: File,
    languageCultureCode: string,
    optionValue: string,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_FLYER_PROMOS_AND_ITEMS_START,
        });

        try {
            let result: any = await postPromotionsAndItemsTemplate(
                flyRecId,
                promosFile,
                languageCultureCode,
                optionValue
            );

            var flyer = result.data.data.flyer;
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_FLYER_PROMOS_AND_ITEMS_SUCCESS, payload: {
                    flyer: flyer,
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });
            dispatch({type: ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE, payload: promosFile});

            dispatch({type: ActionType.POST_FLYER_PROMOS_AND_ITEMS_COMPLETED});
        } catch (err) {
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            // dispatch({type: ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE, payload: promosFile});
            dispatch({
                type: ActionType.POST_FLYER_PROMOS_AND_ITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


export const getEmptyFileForPromosAndItemsData = (lang: string) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_START,
        });

        try {
            let result: any = await getPromotionsAndItemsTemplate(lang);
            dispatch({type: ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_SUCCESS});
            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Template_Lang_${lang === 'he-IL' ? 'Hebrew' : 'English'}_Flyer_Data.xlsx`); //this is the name with which the file will be downloaded
            link.click();
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 0);

            dispatch({type: ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.GET_EMPTY_EXCEL_FLYER_PROMOS_AND_ITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const getExcelFileWithCurrentDataForPromosAndItemsData = (flyerID: number, flyerCaption: string) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_START,
        });

        try {
            let result: any = await getPromotionsAndItemsDataExcel(flyerID);
            dispatch({type: ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_SUCCESS});
            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${flyerCaption}_Flyer_Data.xlsx`); //this is the name with which the file will be downloaded
            link.click();
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 0);

            dispatch({type: ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.GET_CURRENT_DATA_PROMOS_AND_ITEMS_FOR_FLYER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const saveImagesDataForPromotionsItems = (
    flyRecId: number,
    promosFile: File,
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_START,
        });

        try {
            let result: any = await loadImagesForPromoItemsTemplate(
                flyRecId,
                promosFile,
                languageCultureCode
            );

            var flyer = result.data.data.flyer;

            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({type: ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_SUCCESS, payload: flyer});
            dispatch({type: ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE, payload: {}});

            dispatch({type: ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_COMPLETE});
        } catch (err) {
            dispatch({type: ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE, payload: {}});
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const saveImagesDataForPromotions = (
    flyRecId: number,
    promosImages: File[],
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_IMAGES_FOR_PROMOTIONS_START,
        });
        try {
            let result: any = await loadImagesForPromoTemplate(
                flyRecId,
                promosImages,
                languageCultureCode
            );

            dispatch({
                type: ActionType.POST_IMAGES_FOR_PROMOTIONS_SUCCESS,
                payload: {
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });

            dispatch({type: ActionType.POST_IMAGES_FOR_PROMOTIONS_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.POST_IMAGES_FOR_PROMOTIONS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const saveImagesDataForItems = (
    flyRecId: number,
    itemsImages: File[],
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_IMAGES_FOR_ITEMS_START,
        });

        try {
            let result: any = await loadImagesForItemsTemplate(
                flyRecId,
                itemsImages,
                languageCultureCode
            );

            dispatch({
                type: ActionType.POST_IMAGES_FOR_ITEMS_SUCCESS,
                payload: {
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });

            dispatch({type: ActionType.POST_IMAGES_FOR_ITEMS_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.POST_IMAGES_FOR_ITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const savePagePromoItemsData = (
    flyRecId: number,
    promoItemsFile: File,
    languageCultureCode: string
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlippingFlyerActions | FlyerDetailsActions | PromotionsItemsActions>
    ) => {
        dispatch({
            type: ActionType.POST_FLYER_PROMOITEMS_START,
        });

        try {
            let result: any = await postPromoItemsData(
                flyRecId,
                promoItemsFile,
                languageCultureCode
            );

            var flyer = result.data.data.flyer;
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_FLYER_PROMOITEMS_SUCCESS,
                payload: flyer,
            });
            dispatch({type: ActionType.POST_FLYER_PROMOITEMS_COMPLETED});
        } catch (err) {
            dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.POST_FLYER_PROMOITEMS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

const postPageSpotsData = (
    flyerId: number,
    file: File,
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`File`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/UploadFlyerSpotsExcel`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const postPromotionsTemplate = (
    flyerId: number,
    file: File,
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`File`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/UploadFlyerPromosExcel`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const postPromotionsAndItemsTemplate = (
    flyerId: number,
    file: File,
    contentLanguageCulture: string,
    optionValue: string,
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`DuplicateItemAction`, optionValue);
            formData.append(`File`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/UploadFlyerPromosAndPromoItems`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const getPromotionsAndItemsTemplate = (lang: string) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/GetFlyerPromoAndPromoItemsExcelEmpty?uiContentLanguageCultureCode=${lang}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    // "Content-Type": "multipart/form-data",
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
            });
            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })
        }
    });
};

const getPromotionsAndItemsDataExcel = (flyerId: number) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/GetFlyerPromoAndPromoItemsExcel?flyerId=${flyerId}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    // "Content-Type": "multipart/form-data",
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
            });
            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })
        }
    });
};

const loadImagesForPromoItemsTemplate = (
    flyerId: number,
    file: File,
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`File`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/LoadPromoItemImagesFromExcel`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const loadImagesForPromoTemplate = (
    flyerId: number,
    files: File[],
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            const images = [...files];
            images.forEach((file: File) => {
                formData.append(`Images`, file, file.name);
            })

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromos/UploadPromoImages`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const loadImagesForItemsTemplate = (
    flyerId: number,
    files: File[],
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`UserId`, userDto.userId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            const images = [...files]
            images.forEach((file: File) => {
                formData.append(`Images`, file, file.name);
            })

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPromoItems/UploadPromoItemImages`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

const postPromoItemsData = (
    flyerId: number,
    file: File,
    contentLanguageCulture: string
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`FlyerId`, flyerId.toString());
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`File`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };

            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${userDto.userId}/UploadFlyerPromoItemsExcel`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};
